/**
 * API base URL. Empty string = same origin (e.g. Vercel dev or production).
 * Set REACT_APP_API_URL if your API is on a different origin.
 */
export const API_BASE = process.env.REACT_APP_API_URL || ""

export function authFetch(url, options = {}) {
  const token = typeof window !== "undefined" && localStorage.getItem("vista_token")
  const headers = { "Content-Type": "application/json", ...options.headers }
  if (token) headers.Authorization = `Bearer ${token}`
  return fetch(API_BASE + url, { ...options, headers })
}

/**
 * Build query string from params object; skip empty/undefined.
 */
export function buildQuery(params) {
  const search = new URLSearchParams()
  Object.entries(params || {}).forEach(([k, v]) => {
    if (v !== undefined && v !== "" && v !== null) search.set(k, String(v))
  })
  const q = search.toString()
  return q ? `?${q}` : ""
}
